export enum StateCode {
    Active = 0,
    Inactive = 1
}